<template>
    <b-modal id="email-verification-modal" @hidden="resetModalData" hide-footer centered hide-header >
        <b-container fluid style="margin-bottom: 30px;">
            <b-row class=" mb-1 text-center">
                <b-col>
                    <h5 style="color:red; margin-top: 30px;">Παρακαλούμε εισάγετε τον κωδικό επιβεβαίωσης που λάβατε στο email σας</h5>
                </b-col>
            </b-row>
            <b-row class=" mb-1 text-center">
                <b-col>
                    <div style="display: flex; justify-content: center;">
                        <v-otp-input
                                ref="otpInput"
                                input-classes="otp-input"
                                separator="-"
                                :num-inputs="6"
                                :should-auto-focus="true"
                                :is-input-num="true"
                                @on-complete="handleOnComplete"
                        />
                    </div>
                </b-col>
            </b-row>
            <b-container v-if="!isButtonClicked">
                <b-row class="mb-1" align-h="center">
                    <b-col cols="8">
                        <b-button ref="validate" cols="mt-3" variant="success" block @click="getValidationToken">Αποστολή κωδικού</b-button>
                    </b-col>
                </b-row>
            </b-container>
            <b-container v-else>
                <b-row>
                    <b-col>
                        <div style="text-align: center; margin-bottom: 10px">
                            <span v-if="errorMessage" style="color: red;"> *{{ errorMessage }}</span>
                            <span v-if="successMessage" style="color: green"> {{ successMessage }}</span>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="mb-1" align-h="center">
                    <b-col cols="8">
                        <b-button ref="validate" cols="mt-3" variant="success" block @click="validateToken">Επαλήθευση</b-button>
                    </b-col>
                </b-row>
                <b-row align-h="center" style="margin-top: 20px;">
                    <b-button style="font-size: 14px;" ref="validate" cols="mt-3" variant="link" @click="getValidationToken">Αποστολή νέου κωδικού επιβεβαίωσης</b-button>
                </b-row>
            </b-container>

        </b-container>
    </b-modal>
</template>
<script>
    import {HTTP} from "@/main";
    export default {
        name: "EmailVerificationModal",
        data() {
            return {
                pendingSeconds: 0,
                errorMessage: "",
                successMessage: "",
                massage: "",
                otpValue: "",
                isButtonClicked: false,
                interval : null
            }
        },
      
        methods: {
          resetModalData() {
            this.pendingSeconds = 0;
            this.errorMessage = '';
            this.successMessage = '';
            this.massage = '';
            this.otpValue = '';
            this.isButtonClicked = false;
            clearInterval(this.interval);
          },

            handleOnComplete(value) {
                this.otpValue = value;
            },
            getValidationToken() {
                this.isButtonClicked = true
                HTTP.post("/users/email-verify/init?email=" + this.$store.getters.user.email).then(() => {
                    this.errorMessage = null
                    this.successMessage = 'Σας έχει σταλεί κωδικός επιβεβαίωσης στο email που έχετε δηλώσει'
                })
                    .catch(e => {
                      clearInterval(this.interval)
                      const res = e.response;
                      console.log(res)
                      this.successMessage = null
                      this.pendingSeconds = res.data.pendingSeconds + 1;
                      if (!res.data.errorMessage) {
                        this.message = res.data.message;
                        this.startCountDown()
                      } else {
                        this.errorMessage = res.data.errorMessage
                      }
                    })
            },
            validateToken() {
                HTTP.post("/users/email-verify/validate?token="+ this.otpValue).then( () => {
                this.$store.commit("setEmailVerified", true)
                this.$bvModal.hide('email-verification-modal')
                this.$bvToast.toast("Το email επιβεβαιώθηκε επιτυχώς", {
                        title: "ΕΠΙΤΥΧΙΑ",
                        variant: 'success',
                        autoHideDelay: 5000
                    })
                })
                .catch(e => {
                var resp = e.response;
                clearInterval(this.interval)
                this.successMessage = null
                this.errorMessage = resp.data.errorMessage})
            },

            startCountDown() {
                this.interval  = setInterval(this.pendingTime, 1000)
            },
            pendingTime: function() {
                this.pendingSeconds -=1
                let minutes = Math.floor(this.pendingSeconds / 60);
                let seconds = this.pendingSeconds % 60;
                minutes = minutes > 10 ? minutes : `0${minutes}`
                seconds = seconds > 10 ? seconds : `0${seconds}`
                this.errorMessage = this.message + ": " + minutes + ':' + seconds
                if (this.pendingSeconds === 0) {
                    clearInterval(this.interval)
                    this.errorMessage = null
                }
            }
        }
    }
</script>

<style>
.otp-input {
    width: 50px;
    height: 50px;
    padding: 5px;
    margin: 40px 5px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;

    &.error {
        border: 1px solid red !important;
    }
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

@media only screen and (max-width: 600px) {
  .otp-input {
    width: 35px;
    height: 35px;
  }

}
</style>